export class RuleSet
{
  public id: number;
  public name: string;
  public type: any;
  public updateType: any;
  public version: number;
  public taskIds: string[];
  public priority: number;
  public assigneeId: number;
  public assigneeName: string;
  public conditionalWaitId: string;
  public outcome: string;
}

export enum RuleType
{
  enroll,
  update
}

export enum UpdateType
{
  closeTasks,
  closeCases
}
